export const logoBandRefName = 'logoBandRef';

export const logoBandRefProjection = `{
  _id,
 logosPerRow,
 title,
 numberOfRows,
 logos,
}`;

export const logoBandRefQuery = groq`*[_id == $_id][0] ${logoBandRefProjection}`;
